module.exports = __webpack_public_path__ + "static/img/vreemde.3102a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/vreemde.png
// module id = y3H1
// module chunks = 0